<script>
    export let autofocus = false;
    export let title = "OK";
    export let id = "ok";
</script>

<style>

	.dismiss-button {
		display: inline-flex;
		font-size: 0.75rem;
		text-transform: uppercase;
		justify-content: flex-start;
		align-items: center;
		margin: 0;
		padding: 0.625rem 1rem;
	}

	.dismiss-button button {
		width: 1.5rem;
		height: 1.5rem;
		background-size: 100%;
		margin-right: 0.5em;
		margin-bottom: 0;
		cursor: pointer;
	}

	.dismiss-button label {
		display: inline-block;
		font-weight: normal;
		margin-bottom: 0;
		cursor: pointer;
	}

</style>

<div class="dismiss-button light box lev1">
    <!-- svelte-ignore a11y-autofocus -->
    <button autofocus={autofocus} class="action-button green hovery"
    id="{id}" title={title}
    on:click>&nbsp;</button>
    <label for="{id}"><slot></slot></label>
</div>